<template lang="pug">
.message-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onSend" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .send-message-target-modal-header.d-flex.flex-row.align-items-center
        span.menu-title.flex-grow-1 {{ modalTitle }}
      button.close(type="button" @click="cancel") ×

    //- title
    .mb-3
      .d-flex.flex-row.align-items-top
        .flex-grow-1.mr-2
          b-form-input#title(v-model="_title" name="title" placeholder="タイトル" maxlength="100"
            @focus="hideFooter" @blur="showFooter"
            v-validate="{ required: true, max: 100 }" aria-describedby="title" data-vv-as="タイトル")
        .required
          RequireInput
      .error-messages.mt-1(v-if="errors.has('title')")
        label.error-message(v-for="error in errors.collect('title')") {{ error }}
    //- text
    .mb-0
      .d-flex.flex-row.align-items-top
        .flex-grow-1.mr-2
          b-form-textarea#text(v-model="_text" name="text" placeholder="本文" rows="6" max-rows="6" maxlength="1000"
            @focus="hideFooter" @blur="showFooter"
            v-validate="{ required: true, max: 1000 }" aria-describedby="text-live-feedback" data-vv-as="本文")
        .required
          RequireInput
      .error-messages.mt-1(v-if="errors.has('text')")
        label.error-message(v-for="error in errors.collect('text')") {{ error }}

    template(#modal-footer="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル

</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ValidationAlert from "@/mobile/basics/ValidationAlertByValidator.vue";
import RequireInput from "@/mobile/basics/RequireInput.vue";

/**
 * ### メッセージ送信内容入力モーダル
 */
@Component({
  components: {
    ValidationAlert,
    RequireInput
  },
  $_veeValidate: { validator: "new" }
})
export default class MessageModal extends Vue {
  @Prop()
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  modalTitle!: string;
  /** モーダルメッセージ */
  @Prop()
  modalMessage!: string;
  /** メッセージタイトル */
  @Prop()
  title!: string;
  /** メッセージ本文 */
  @Prop()
  text!: string;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }

  set _title(newValue: string) {
    this.$emit("update:title", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public async onSend(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("onSend");
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public cancel(): void {
    this.showValidationAlert = false;
    return;
  }

  /**
   * ### フッターを表示する
   */
  public showFooter(): void {
    this.$emit("updateShowFooter", true);
    return;
  }

  /**
   * ### フッターを非表示にする
   */
  public hideFooter(): void {
    this.$emit("updateShowFooter", false);
    return;
  }
}

export enum TestMailTargetType {
  /** 種別無し */
  NONE = 0,
  /** 家族ユーザー */
  FAMILY = 1,
  /** 施設関係者 */
  OTHER_USER_GROUP_MEMBER = 2
}
</script>
